import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

function RadioEssayList() {
  const [essays, setEssays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/essays/`)
      .then((res) => {
        setEssays(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to load essays.");
        setLoading(false);
      });
  }, []);

  if (loading) return <p className="essay-status">Loading...</p>;
  if (error) return <p className="essay-status">{error}</p>;

  return (
    <div className="essay-list">
      <header className="essay-list-header">
        <Link to="/" className="back-link" aria-label="Back to home">
          &larr;
        </Link>
        <h1>Radio Essays</h1>
      </header>
      {essays.length === 0 ? (
        <p className="essay-status">No essays yet.</p>
      ) : (
        <ul className="essay-items">
          {essays.map((essay) => (
            <li key={essay.id} className="essay-item">
              <Link to={`/essays/${essay.id}`} className="essay-link">
                <h2 className="essay-item-title">{essay.title}</h2>
                <p className="essay-item-summary">{essay.summary}</p>
                <time className="essay-item-date" dateTime={essay.aired_at}>
                  {new Date(essay.aired_at).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </time>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default RadioEssayList;
